import clsx from 'clsx';
import { observer } from 'mobx-react';
import { Link } from 'react-router-dom';
import { T, TPlainTextKey } from '../../../../Translations';
import CountStore from '../../CountStore';
import { Segment, segmentPath } from '../../Segment';
import SegmentCount from './SegmentCount';

interface Props {
  segment: Segment;
  current: Segment;
  label: TPlainTextKey;
  countStore: CountStore;
}

/**
 * Each segment is a route, so it is a link with aria-current rather than an
 * ARIA tab: it behaves exactly like navigation and is announced that way.
 */
function SegmentTab({ segment, current, label, countStore }: Props) {
  const selected = segment === current;

  return (
    <Link
      to={segmentPath(segment)}
      aria-current={selected ? 'page' : undefined}
      className={clsx(
        'rounded-md px-3 py-1.5 transition-colors focus:outline-none focus:ring-2 focus:ring-ring',
        selected
          ? 'bg-card text-foreground shadow-sm'
          : 'text-muted-foreground hover:text-foreground',
      )}
      style={{ fontSize: 'var(--text-sm)', fontWeight: 'var(--font-weight-medium)' }}
      data-intercom-target={`people-v2-${segment}-segment-tab`}
    >
      <T kind={label} />
      <SegmentCount store={countStore} />
    </Link>
  );
}

export default observer(SegmentTab);
